<template>
  <div class="min-h-screen px-6 py-8 md:px-10">
    <div class="w-full space-y-6">
      <div class="flex flex-col gap-4 lg:flex-row lg:items-end lg:justify-between">
        <div>
          <h1 class="mt-2 text-3xl text-gray-900">Nova Validação</h1>
          <p class="mt-2 max-w-2xl text-sm text-gray-500">Envie um arquivo para validação e visualize a amostra antes de salvar.</p>
        </div>

        <div class="flex flex-col gap-3 sm:flex-row">
          <button
            type="button"
            class="icon-anim-trigger--back group flex h-11 items-center justify-center gap-2 rounded-xl border border-gray-200 bg-white px-5 font-medium text-gray-700 shadow-sm transition-all duration-200 hover:-translate-y-0.5 hover:border-gray-300 hover:bg-gray-50 hover:shadow-md"
            @click="voltar"
          >
            <svg class="icon-anim icon-anim--back h-5 w-5 text-gray-500 group-hover:text-blue-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15.75 19.5L8.25 12l7.5-7.5" />
            </svg>
            Voltar
          </button>

          <a
            href="/arquivo-modelo-lembrazap-validacao.xlsx"
            download
            class="flex h-11 items-center justify-center gap-2 rounded-xl border border-gray-200 bg-white px-5 font-medium text-gray-700 shadow-sm transition-all duration-200 hover:-translate-y-0.5 hover:border-gray-300 hover:bg-gray-50 hover:shadow-md"
          >
            <svg class="h-5 w-5 text-green-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 3v12m0 0l-3.5-3.5M12 15l3.5-3.5M4 21h16" />
            </svg>
            Download modelo
          </a>
        </div>
      </div>

      <form @submit.prevent="salvar" class="space-y-6">
        <div class="rounded-2xl border border-gray-200 bg-white p-6 shadow-sm">
          <div class="mb-6">
            <h2 class="text-lg font-semibold text-gray-900">Dados da validação</h2>
            <p class="mt-1 text-sm text-gray-500">Informe a identificação e o centro de custo antes de importar.</p>
          </div>

          <div class="grid grid-cols-1 gap-6 lg:grid-cols-2">
            <div class="flex flex-col gap-1">
              <label class="text-sm font-medium text-gray-500"> Identificação (nome do arquivo automático) </label>
              <input v-model="form.identificacao" type="text" :class="ui.inputField" />
            </div>

            <div class="flex flex-col gap-1" v-if="$store.state.user && $store.state.user.admin">
              <label class="text-sm font-medium text-gray-500"> Centro de custo </label>

              <div class="relative group">
                <select
                  id="centrocusto-validacao-import"
                  v-model="form.centroCusto"
                  class="w-full h-11 px-4 pr-10 border border-gray-200 rounded-xl bg-white bg-none text-gray-700 shadow-sm appearance-none transition-all duration-200 focus:border-blue-100 focus:ring-2 focus:ring-blue-100 cursor-pointer"
                >
                  <option value="">Selecione</option>
                  <option v-for="c in centros" :key="c._id" :value="c._id">
                    {{ c.nome }}
                  </option>
                </select>

                <svg class="select-icon w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
                </svg>
              </div>
            </div>
          </div>
        </div>

        <div class="grid grid-cols-1 gap-6 xl:grid-cols-2">
          <div class="rounded-2xl border border-gray-200 bg-white p-6 shadow-sm">
            <div class="mb-6">
              <h2 class="text-lg font-semibold text-gray-900">Arquivo para importar</h2>
              <p class="mt-1 text-sm text-gray-500">Selecione ou arraste o arquivo da campanha.</p>
            </div>

            <input ref="fileInput" type="file" class="hidden" accept=".csv,.xlsx,.xls,.txt" @change="handleFile" />

            <button
              type="button"
              class="flex min-h-64 w-full flex-col items-center justify-center rounded-[28px] border-2 border-dashed px-6 text-center transition"
              :class="dragging ? 'border-blue-400 bg-white' : 'border-gray-200 bg-white hover:border-blue-300'"
              @click="openFile"
              @dragover.prevent="dragging = true"
              @dragleave.prevent="dragging = false"
              @drop.prevent="dropFile"
            >
              <svg class="h-8 w-8 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 15a4 4 0 014-4h1a5 5 0 119.6 1.5A3.5 3.5 0 1118 19H7a4 4 0 01-4-4zm9-6v8m0 0l3-3m-3 3l-3-3" />
              </svg>

              <p class="mt-3 text-base font-medium text-gray-700">Clique ou arraste o arquivo da campanha aqui</p>

              <p class="mt-2 max-w-sm text-sm text-gray-400">CSV, XLSX, XLS ou TXT.</p>
            </button>

            <div class="mt-4 rounded-xl border border-gray-200 bg-gray-50 px-4 py-3 text-sm text-gray-600">
              {{ file ? file.name : "Nenhum arquivo selecionado." }}
            </div>
          </div>

          <div class="rounded-2xl border border-gray-200 bg-white p-6 shadow-sm">
            <div class="flex flex-col gap-3 border-b border-gray-100 pb-5 lg:flex-row lg:items-start lg:justify-between">
              <div>
                <h2 class="text-lg font-semibold text-gray-900">Amostra de números</h2>
                <p class="mt-1 text-sm text-gray-500">Visualize os registros carregados antes de salvar.</p>
              </div>

              <p class="rounded-xl border border-gray-200 bg-white px-4 py-3 text-sm text-gray-500 shadow-sm">{{ preview.length }} contatos</p>
            </div>

            <div class="mt-6 overflow-hidden rounded-2xl border border-gray-200 bg-slate-50">
              <div class="border-b border-gray-200 bg-white px-5 py-4">
                <span class="text-sm font-medium uppercase tracking-[0.2em] text-gray-500"> Números </span>
              </div>

              <div class="max-h-[26rem] overflow-y-auto bg-white">
                <div v-if="preview.length" class="divide-y divide-gray-100">
                  <div v-for="(item, index) in preview" :key="`${item}-${index}`" class="px-5 py-3 text-sm text-gray-700 transition hover:bg-slate-50">
                    {{ item }}
                  </div>
                </div>

                <div v-else class="flex min-h-80 items-center justify-center px-6 text-sm text-gray-400">Nenhum dado carregado.</div>
              </div>
            </div>
          </div>
        </div>

        <div class="flex justify-end">
          <button
            type="submit"
            class="flex h-11 items-center justify-center gap-2 rounded-xl border border-gray-200 px-5 font-medium text-white shadow-sm transition-all duration-200 hover:-translate-y-0.5 hover:shadow-md"
            :style="{ backgroundColor: primaryColor }"
            @mouseenter="$event.target.style.backgroundColor = mixPrimaryColor('#111827', 0.2)"
            @mouseleave="$event.target.style.backgroundColor = primaryColor"
          >
            Salvar validação
          </button>
        </div>
      </form>

      <div v-if="isLoading" class="fixed left-0 top-80 z-50 w-full text-center text-lg font-bold text-zinc-600">
        <span class="text-green-600">{{ progresso }}</span> / 100%
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import { colorMixin } from "@/utils/colorMixin";

export default {
  mixins: [colorMixin],
  data() {
    return {
      isLoading: false,
      progresso: 0,
      centroscusto: [],
      preview: [],
      file: null,
      dragging: false,
      ui: {
        inputField: "h-11 border border-gray-200 shadow-sm rounded-xl px-4 outline-none focus:border-blue-100 focus:ring-2 focus:ring-blue-100",
        selectField:
          "h-11 w-full cursor-pointer appearance-none rounded-xl border border-gray-200 bg-white px-4 pr-10 text-gray-700 shadow-sm outline-none transition-all duration-200 focus:border-blue-100 focus:ring-2 focus:ring-blue-100",
        selectIcon: "select-icon pointer-events-none absolute right-3 top-1/2 h-5 w-5 -translate-y-1/2 text-gray-400 transition-all duration-200 group-focus-within:text-blue-600"
      },
      form: {
        identificacao: "",
        centroCusto: "",
        file: "",
        arquivo: "",
        validacao: true
      }
    };
  },
  computed: {
    centros() {
      return this.centroscusto;
    }
  },
  mounted() {
    const userId = this.$store && this.$store.state && this.$store.state.user ? this.$store.state.user._id : null;
    if (!userId) return;

    this.sockets.subscribe(`progressao_${userId}`, (progresso) => {
      this.progresso = progresso;
    });
  },
  beforeDestroy() {
    const userId = this.$store && this.$store.state && this.$store.state.user ? this.$store.state.user._id : null;
    if (!userId) return;
    this.sockets.unsubscribe(`progressao_${userId}`);
  },
  methods: {
    voltar() {
      this.$router.push({ path: "/temzap" });
    },
    openFile() {
      this.$refs.fileInput.click();
    },
    async handleFile(event) {
      const selected = event.target && event.target.files ? event.target.files[0] : null;
      if (!selected) return;

      this.file = selected;
      this.form.file = selected;
      await this.loadPreview(selected);
    },
    async dropFile(event) {
      this.dragging = false;
      const selected = event.dataTransfer && event.dataTransfer.files ? event.dataTransfer.files[0] : null;
      if (!selected) return;

      this.file = selected;
      this.form.file = selected;
      await this.loadPreview(selected);
    },
    async loadPreview(selected) {
      try {
        const data = new FormData();
        data.append("file", selected);
        const response = await this.$http.post("/v1/campanhasLZV2/preview-campanha-import", data);
        const rawPreview = response && response.data && response.data.data ? response.data.data : [];
        this.preview = rawPreview
          .map((item) => {
            if (item && item.contato && item.contato.telefone) return item.contato.telefone;
            if (typeof item === "string") return item;
            return "";
          })
          .filter(Boolean);
      } catch (error) {
        this.preview = [];
        this.$vToastify.error("Erro ao gerar amostra do arquivo");
      }
    },
    async salvar() {
      if (!this.form.file) {
        return this.$vToastify.error("Selecione um arquivo para importar");
      }

      const dataEnvio = new FormData();

      dataEnvio.append("file", this.form.file);
      dataEnvio.append("arquivo", JSON.stringify(this.form.arquivo));
      dataEnvio.append("dataHoraDisparo", new Date());
      dataEnvio.append("nome", this.form.identificacao);
      dataEnvio.append("validacao", this.form.validacao);

      this.isLoading = true;
      let loader = this.$loading.show({
        container: null,
        canCancel: true
      });

      if (this.$store.state.user.lzv2.centrocusto && !this.form.centroCusto) {
        loader.hide();
        this.isLoading = false;
        return this.$vToastify.error("Selecione o centro de custo");
      }

      if (this.form.centroCusto) {
        dataEnvio.append("centrocusto", this.form.centroCusto);
      }

      let result;
      try {
        result = await this.$http.post("/v1/campanhasLZV2/gerar-campanha-import", dataEnvio);
      } catch (error) {
        this.isLoading = false;
        loader.hide();
        return this.$vToastify.error("Erro ao salvar validação");
      }

      this.isLoading = false;
      loader.hide();
      if (result.data.success) {
        this.$router.push({ path: "/temzap" });
      } else {
        this.$vToastify.error(result.data.err);
      }
    }
  },
  async beforeMount() {
    this.form.identificacao = `${moment().format("x")}`;
    this.form.validacao = true;

    const centroscustoReq = await this.$http.post(`/v1/centrocusto/list`, { all: true });
    if (centroscustoReq.data && centroscustoReq.data.data) this.centroscusto = centroscustoReq.data.data;

    if (this.$store.state.user && this.$store.state.user.centrocusto && !this.$store.state.user.admin) {
      this.form.centroCusto = this.$store.state.user.centrocusto;
    }
  }
};
</script>

<style scoped>
#centrocusto-validacao-import {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  background-image: none !important;
}

#centrocusto-validacao-import::-ms-expand {
  display: none;
}

.select-icon {
  position: absolute;
  right: 0.75rem;
  top: 50%;
  pointer-events: none;
  color: #9ca3af;
  transform: translateY(-50%);
  transition: transform 0.2s ease, color 0.2s ease;
}

.group:focus-within .select-icon {
  color: #6366f1;
  transform: translateY(-50%) rotate(180deg);
}
</style>
